import { NgModule } from "@angular/core";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { QueueComponent } from "./queue/queue.component";
import { RunnersComponent } from "./runners/runners.component";
import { RunningTasksComponent } from "./running-tasks/running-tasks.component";
import { StatisticsComponent } from "./statistics/statistics.component";
import { RouterModule } from "@angular/router";
import { DashboardComponent } from "./dashboard.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ResourcesStatusComponent } from "./resources-status/resources-status.component";
import { ComingSoonComponent } from '@nucleus/ui-common';


@NgModule({
  declarations: [
    QueueComponent,
    RunnersComponent,
    RunningTasksComponent,
    StatisticsComponent,
    DashboardComponent,
    ResourcesStatusComponent
  ],
  imports: [RouterModule, DashboardRoutingModule, MatToolbarModule, ComingSoonComponent],
  bootstrap: [DashboardComponent]
})
export class DashboardModule {}
